import axios, { AxiosHeaders } from "axios";
import { API_CONFIG } from "./apiConfig";
import { getOwnerAccessToken } from "../auth/ownerAccessToken";

const instance = axios.create({
  baseURL: API_CONFIG.baseUrl + API_CONFIG.v1Path,
});

instance.interceptors.request.use((config) => {
  const token = getOwnerAccessToken();
  if (!token) {
    return config;
  }

  if (!config.headers) {
    config.headers = new AxiosHeaders();
  }

  if (typeof config.headers.set === "function") {
    config.headers.set("Authorization", `Bearer ${token}`);
  } else {
    (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }

  return config;
});

export default instance;
